// Socials.tsx
import React from "react";
import { Mail, Linkedin, Link as LinkIcon, Github } from "lucide-react";
import { FaXTwitter } from "react-icons/fa6";

interface Social {
  href: string;
  ariaLabel: string;
  icon: JSX.Element;
}

interface SocialsProps {
  socials?: Social[];
}

const defaultSocials: Social[] = [
  {
    href: "https://linktr.ee/zein.alamah",
    ariaLabel: "Linktree Profile",
    icon: <LinkIcon size={22} />,
  },
  {
    href: "https://github.com/zeinalamah",
    ariaLabel: "GitHub Profile",
    icon: <Github size={22} />,
  },
  {
    href: "https://www.linkedin.com/in/zein-alamah/",
    ariaLabel: "LinkedIn Profile",
    icon: <Linkedin size={22} />,
  },
  {
    href: "https://x.com/zein_alamah",
    ariaLabel: "X (Twitter) Profile",
    icon: <FaXTwitter size={20} />,
  },
  {
    href: "mailto:zein@zeinalamah.com",
    ariaLabel: "Email Contact",
    icon: <Mail size={22} />,
  },
];

const Socials: React.FC<SocialsProps> = ({ socials = defaultSocials }) => {
  return (
    <div className="flex justify-center gap-6 mb-6">
      {socials.map((social, index) => (
        <a
          key={index}
          href={social.href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-text hover:text-primary transition-colors"
          aria-label={social.ariaLabel}
        >
          {social.icon}
        </a>
      ))}
    </div>
  );
};

export default Socials;
